import { CommandContribution } from '@patsnap/tahiti-core';
import { ContainerModule, type interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { WireFrameExtractCommandContribution } from './impls/wire-frame-extract-command-contribution';
import { WireFrameExtractDialogService } from './wire-frame-extract-dialog-service';
import { wireFrameExtractDialogServiceFactory } from './impls/wire-frame-extract-dialog-service';
import { WireFrameExtractMessageServiceImpl } from './impls/wire-frame-extract-message-service';
import { WireFrameExtractSubmissionServiceImpl } from './impls/wire-frame-extract-service';
import { WireFrameExtractMessageService } from './wire-frame-extract-message-service';
import { WireFrameExtractSubmissionService } from './wire-frame-extract-service';
import { WireFrameExtractCommand } from './impls/wire-frame-extract-command';
import { WireFrameExtractServiceImpl } from '../wire-frame-extract/impls/wire-frame-extract-service';
import { WireFrameExtractService } from '../wire-frame-extract/wire-frame-extract-service';

export const wireFrameExtractDialogModule = new ContainerModule((bind: interfaces.Bind) => {
    bind(WireFrameExtractDialogService).toDynamicValue(wireFrameExtractDialogServiceFactory());
    bind(CommandContribution).to(WireFrameExtractCommandContribution);
    bind(WireFrameExtractSubmissionService).to(WireFrameExtractSubmissionServiceImpl);
    bind(WireFrameExtractMessageService).to(WireFrameExtractMessageServiceImpl);
    bind(WireFrameExtractCommand).toSelf();
    bind(WireFrameExtractService).to(WireFrameExtractServiceImpl);
});
